<div class="dashboard">
  <app-header />

  <main class="dashboard-content">
    <!-- Cabeçalho com título e seletor de data -->
    <div class="dashboard-header">
      <!-- Título com ícone e textos -->
      <div class="title-section">
        <img src="assets/icons/titleLogoLeads.svg" alt="Leads" class="title-icon" />
        <span class="title-leads">Leads</span>
      </div>

      <!-- Seletor de data -->
      <div class="period-section">
        <div class="period-content">
          <img src="assets/icons/periodCalendar.png" alt="Calendário" class="calendar-icon" />
          <span class="period-title">Período</span>
        </div>
      </div>

      <!-- Seletor de data -->
      <app-dashboard-date-selector (dateRangeChange)="onDateRangeChange($event)" />

      <app-export-document-button
        class="export-button"
        [disabled]="isExporting || !currentStartDate || !currentEndDate"
        [initialStartYear]="exportStartYear"
        [initialStartMonth]="exportStartMonth"
        [initialEndYear]="exportEndYear"
        [initialEndMonth]="exportEndMonth"
        (exportDirect)="onExportLeadsRequested()"
      />

      <app-export-download-modal
        [show]="showExportModal"
        [fileName]="exportFileName"
        [fileBlob]="exportFileBlob"
        [emailSubject]="exportEmailSubject"
        [emailBody]="exportEmailBody"
        [simpleDisclaimerMode]="true"
        [warningTitle]="'Importante'"
        [warningPrefix]="'Recomendações de LGPD:'"
        [warningMessage]="
          ' Não compartilhe dados sensíveis e pessoais de clientes com terceiros e, tão logo a ativação dos clientes seja concluída, os dados devem ser expurgados.'
        "
        (close)="handleExportModalClose()"
        (download)="handleExportModalDownload()"
      />
    </div>

    <!-- Cards superiores - Desktop e Mobile condicionais -->
    <!-- Desktop: summary-card (com hover) -->
    <div class="cards-grid desktop-cards">
      @for (card of cards; track $index) {
        <app-summary-card [data]="card" [hasMask]="shouldHaveMask($index)" class="card-item" />
      }
    </div>

    <!-- Mobile/Tablet: summary-card-mobile (sem hover) -->
    <div class="cards-grid mobile-cards">
      @for (card of cards; track $index) {
        <app-summary-card-mobile
          [data]="card"
          [hasMask]="shouldHaveMask($index)"
          (openInfoModal)="openInfoModal($event)"
          class="card-item"
        />
      }
    </div>

    <!-- Linha dos gráficos -->
    <div class="charts-row">
      <div class="summary-blocks-container">
        @for (block of summaryBlocks; track $index) {
          <app-summary-blocks
            [data]="block"
            [hasMask]="shouldHaveMaskSummaryBlock($index)"
            (openInfoModal)="openInfoModal($event)"
          />
        }
      </div>

      <!-- Gráfico Vertical -->
      <app-card-mask class="chart-shell chart-shell--wide" [hasMask]="chartsHaveMask">
        <div class="chart-card vertical-chart">
          <!-- Botão de Informação - MESMO ESTILO ORIGINAL, apenas adicionado (click) -->
          <button
            mat-icon-button
            class="info-button"
            [attr.data-tooltip]="
              'Apresenta o desempenho mensal dos Leads, incluindo o volume recebido, o volume trabalhado e as taxas de conversão e de Leads trabalhados em relação ao total disponibilizado no mês. Todo Lead com status diferente de Pendente é considerado como Lead trabalhado.'
            "
            (click)="
              onChartInfoClick(
                'Gráfico Mensal',
                'Apresenta o desempenho mensal dos Leads, incluindo o volume recebido, o volume trabalhado e as taxas de conversão e de Leads trabalhados em relação ao total disponibilizado no mês. Todo Lead com status diferente de Pendente é considerado como Lead trabalhado.'
              )
            "
          >
            <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon" />
          </button>

          <!-- Gráfico -->
          <app-vertical-bar-chart [data]="graficoMensalData" [loading]="loadingGraficos" />
        </div>
      </app-card-mask>

      <!-- Gráfico Donut (Pizza) COM BOTÃO DE INFORMAÇÃO -->
      <app-card-mask class="chart-shell chart-shell--side" [hasMask]="chartsHaveMask">
        <div class="chart-card donut-chart">
          <!-- Botão de Informação - MESMO ESTILO ORIGINAL, apenas adicionado (click) -->
          <button
            mat-icon-button
            class="info-button"
            [attr.data-tooltip]="
              'Percentual de Leads em negociação e Leads pendentes em relação ao total de Leads disponibilizados no intervalo analisado.'
            "
            (click)="
              onChartInfoClick(
                'Gráfico Percentual',
                'Percentual de Leads em negociação e Leads pendentes em relação ao total de Leads disponibilizados no intervalo analisado.'
              )
            "
          >
            <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon" />
          </button>

          <!-- Gráfico Donut -->
          <app-donut-chart [data]="graficoPercentualData" [loading]="loadingGraficos" />
        </div>
      </app-card-mask>
    </div>
  </main>

  <!-- MODAL DE INFORMAÇÕES PARA MOBILE -->
  @if (infoModalData.isOpen) {
    <div class="info-modal" [class.active]="infoModalData.isOpen">
      <div class="modal-overlay" (click)="closeInfoModal()"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h3>Sobre {{ infoModalData.title }}</h3>
          <button class="close-button" (click)="closeInfoModal()">✕</button>
        </div>
        <div class="modal-body">
          <p class="info-message">{{ infoModalData.message }}</p>
        </div>
        <div class="modal-footer">
          <button class="button-confirm" (click)="closeInfoModal()">Entendi</button>
        </div>
      </div>
    </div>
  }
</div>
